module.exports = __webpack_public_path__ + "static/media/12_fireball.ba34de65.gif";